
import React, { useRef, useState } from 'react';
import { Region } from '../../data/types/region-types';
import { City } from '../../data/types/city-types';
import MexicoMap from '../map';

interface MapContainerProps {
  regions: Region[];
  onRegionClick: (region: Region) => void;
  filteredRegionIds?: string[];
  selectedRegion: Region | null;
  selectedCity: City | null | undefined;
  wasInMexicoView: boolean;
  onCityClick: (city: City) => void;
  handleGoBack?: () => void;
  isChiapasActive?: boolean;
  isHidalgoActive?: boolean;
  mapRef?: React.RefObject<any>;
  showFunding?: boolean;
  showLowPresence?: boolean;
  showUnreached?: boolean;
  showAreasOfNeed?: boolean;
  setShowFunding?: (show: boolean) => void;
}

const MapContainer: React.FC<MapContainerProps> = ({
  regions,
  onRegionClick,
  filteredRegionIds,
  selectedRegion,
  selectedCity,
  wasInMexicoView,
  onCityClick,
  handleGoBack,
  isChiapasActive = false,
  isHidalgoActive = false,
  mapRef,
  showFunding = true,
  showLowPresence = true,
  showUnreached = true,
  showAreasOfNeed = true,
  setShowFunding = () => {}
}) => {
  return (
    <div className="w-full h-full relative">
      <MexicoMap
        regions={regions}
        onRegionClick={onRegionClick}
        filteredRegionIds={filteredRegionIds}
        selectedRegion={selectedRegion}
        selectedCity={selectedCity}
        wasInMexicoView={wasInMexicoView}
        onCityClick={onCityClick}
        handleGoBack={handleGoBack}
        isChiapasActive={isChiapasActive}
        isHidalgoActive={isHidalgoActive}
        ref={mapRef}
        showFunding={showFunding}
        showLowPresence={showLowPresence}
        showUnreached={showUnreached}
        showAreasOfNeed={showAreasOfNeed}
        setShowFunding={setShowFunding}
      />
    </div>
  );
};

export default MapContainer;
